import Body from '~/components/Modal/Body';
import Container, { MobileContainer } from '~/components/Modal/Container';
import Footer, { MobileFooter } from '~/components/Modal/Footer';
import Header from '~/components/Modal/Header';
import { ZIndexContext } from '~/components/Modal/OuterContainer';
import Title from '~/components/Modal/Title';

export default {
  Body,
  Container,
  Footer,
  Header,
  MobileContainer,
  MobileFooter,
  Title,
  ZIndexContext,
};
